export default __webpack_public_path__ + "static/media/demo_1.a8b08f0c.jpg";